import {mergeProperties, reverseEnum} from "../components/Utility";
import {FinancialSource, Status} from "../enums/enums";

export const getFormData = (data) => {
    const initialData = {
        name: '',
        source: '',
        systemGen: '',
        status: true,
        description: '',
    };
    return mergeProperties(initialData, data);
};

export const getTableColumns = ({ ActionDropdown, deleteHandler }) => {
    let tableColumns = [
        { header: "Name", field: "name" },
        { header: "Source", field: "source" },
        { header: "Description", field: "description" },
    ];

    tableColumns.push({
        header: "Action",
        disableSorting: true,
        field: "action",
        align: "right",
        render: (row) => <ActionDropdown row={row} onDelete={deleteHandler} />,
    });

    return tableColumns;
};

export const getTableData = ({ items = [] }) => {
    if (!Array.isArray(items)) return [];
    return items.map((item) => ({
        id: item.id,
        name: item.name,
        source: reverseEnum(FinancialSource)[item.source],
        systemGen: item?.systemGen,
        description: item.description,
    }));
};

export const getDetailData = ({ item }) => {
    if (!item) return { details: {} };
    return {
        details: {
            id: item.id,
            name: item.name,
            source: reverseEnum(FinancialSource)[item.source],
            systemGen: item.systemGen ? "Yes" : "No",
            description: item.description,
            status: reverseEnum(Status)[item.status]
        },
    };
};
